module.exports = "<div #reportContainer style=\"width: 100%; height: 100vh;\"></div>"